var _style, _g, _ellipse, _polyline, _polyline2, _polyline3, _polyline4, _path, _path2, _path3, _polyline5, _polyline6, _polygon, _polyline7, _polyline8, _polyline9, _polyline10, _polygon2, _polyline11, _path4, _polyline12, _path5, _path6, _path7, _polygon3, _polygon4, _polyline13, _g2, _g3, _g4, _line, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaidaLogoFaded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 624 616",
    style: {
      enableBackground: "new 0 0 624 616"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.7;}\n\t.st2{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#131313;stroke-width:1.2;stroke-miterlimit:10;}\n\t.st4{opacity:0.5;}\n\t.st5{fill:#050505;stroke:#050505;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "593.8,305.6 587.5,365.6 569.2,421 539.3,472.2 502.3,513.7 464.7,541.5 412.9,567.2 357,582.3  311.9,586.7 266.2,582.3 211.1,567.2 159.1,541.8 121.4,513.7 83.9,471.6 54.4,420.9 36.4,366.1 29.9,305.6 36,246.9 54.2,190.9  82.7,141.4 118.7,100.8 158.6,69.6 221.7,39.2 267.1,28.2 312.1,25.1 355.5,28.1 399.4,38.5 465.5,69.2 505.4,100.6 542,142.6  570.5,193.1 587.8,247.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,247.1l33.2-9.3l0,0l0,0l30-2.8l30-2.7l30-2.6l3.8-0.3l1.9-0.2h0.5h0.2h0.3h0.9l7.5-0.2l15.1-0.4 l120.5-2.9h0.5h0.2h0.3h0.9h1.9l3.8,0.1l7.5,0.2l15.1,0.4l30.1,0.7l60.3,1.4l15.1,0.4l3.8,0.1l1.9,0.1h0.9l1,0.1l7.5,0.6l30,2.6 l30,2.6l30,2.7l0,0l0,0l33.9,10.3l-34.1-9.6h0.1l-30.1-2.1l-30.1-2.2l-30.1-2.2l-7.5-0.6l-0.9-0.1h-0.9h-1.9l-3.8-0.1l-15.1-0.2 l-120.5-2.3l-120.5,2.4l-15.1,0.2l-7.5,0.1h-0.9h-0.1h-0.1h-0.2h-0.5l-1.9,0.1l-3.8,0.3l-30.1,2.3l-30.1,2.3l-30.1,2.2h0.1 L37.6,247.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.2,190.6l16.4-7.9l16.4-7.9h0.1h0.1l23-3.4l23-3.3l46-6.5l0,0h0.1c11-0.5,22-1,33-1.5l33-1.4l66-2.7h0.1 h0.1l65,2.5l32.5,1.3l16.3,0.6l16.3,0.7h0.1l0,0l46.8,6.7l23.4,3.4l23.4,3.4h0.1h0.1l16.6,9.1l16.6,9.2l-16.8-8.7l-16.8-8.8h0.2 l-23.5-3l-23.5-3l-46.9-6.1h0.1l-16.3-0.5l-16.3-0.6l-32.5-1.1l-65-2.3h0.1l-66.1,2.5l-33,1.2c-11,0.4-22,0.8-33,1.1h0.1l-46.1,6 l-23,3l-23.1,2.9h0.1l-16.5,7.5L55.2,190.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.6,141.1l15.8-8.5l15.9-8.4h0.1h0.1l24.2-5.5c4-0.9,8.1-1.8,12.1-2.7l12.1-2.6l12.1-2.5l12.2-2.4l6.1-1.1 l3.1-0.5c1.1-0.2,2.1-0.3,3.1-0.4c2-0.3,4.1-0.4,6.2-0.6l6.2-0.5l12.4-0.9c4.1-0.3,8.2-0.5,12.4-0.7l24.7-1.3 c16.5-0.8,33-1.5,49.5-2.2h0.1h0.1l56.6,3.2l28.3,1.6l28.3,1.8h0.1h0.1l41.1,8.3l41.1,8.4h0.1h0.1l17,9.5l16.9,9.6l-17.2-9 l-17.2-9.1l0.2,0.1l-41.2-7.9l-41.2-7.9h0.1l-28.3-1.3l-28.3-1.4l-56.6-2.9h0.1c-16.5,0.6-33,1.2-49.5,1.9l-24.7,1.1l-12.4,0.6 l-12.4,0.6l-6.2,0.4c-2,0.2-4.1,0.3-6.1,0.5c-1,0.1-2.1,0.2-3.1,0.3l-3,0.5l-6.1,1l-12.4,2.5l-12.1,2.4 c-16.2,3.3-32.4,6.6-48.5,10h0.1l-16.1,8.1L83.6,141.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.8,69.2c6.3-0.9,12.6-1.8,18.9-2.7c6.3-0.9,12.6-1.8,18.9-2.6l18.9-2.5l4.7-0.6l2.4-0.3l2.4-0.2l9.5-0.7 l38-2.5l38-2.4h0.1h0.1l43.2,1.9l43.2,2h0.1h0.1l33.4,5.2c5.6,0.8,11.1,1.8,16.7,2.7c5.6,0.9,11.1,1.8,16.6,2.8 c-5.6-0.6-11.2-1.2-16.8-1.9c-5.6-0.7-11.2-1.3-16.8-2l-33.5-4.2h0.1l-43.2-1.6l-43.2-1.8h0.2l-38,2.2l-38,2.1l-9.5,0.5l-2.3,0.1 l-2.4,0.3l-4.7,0.5l-18.9,2c-6.3,0.7-12.6,1.3-19,1.9C172.4,68.2,166.1,68.8,159.8,69.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.9,306.5c0,0,8.8-0.1,24.2-0.3c7.7-0.1,17-0.2,27.8-0.3c10.7-0.1,22.8-0.2,36-0.3 c13.2-0.1,27.5-0.2,42.6-0.2c15.1-0.1,31.1-0.2,47.6-0.2c33-0.1,68.2-0.1,103.4-0.2c35.2,0.1,70.4,0.1,103.4,0.2 c16.5,0,32.4,0.1,47.6,0.2c15.1,0.1,29.4,0.2,42.6,0.2c13.2,0.1,25.3,0.2,36,0.3c10.7,0.1,20.1,0.2,27.8,0.3 c15.4,0.2,24.2,0.3,24.2,0.3s-8.8,0.1-24.2,0.3c-7.7,0.1-17,0.2-27.8,0.3c-10.7,0.1-22.8,0.2-36,0.3c-13.2,0.1-27.5,0.2-42.6,0.2 c-15.1,0.1-31.1,0.2-47.6,0.2c-33,0.1-68.2,0.1-103.4,0.2c-35.2-0.1-70.4-0.1-103.4-0.2c-16.5,0-32.4-0.1-47.6-0.2 c-15.1-0.1-29.4-0.2-42.6-0.2c-13.2-0.1-25.3-0.2-36-0.3c-10.7-0.1-20.1-0.2-27.8-0.3C38.7,306.5,29.9,306.5,29.9,306.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.7,365.9l32.6,8.5h-0.1l30.1,2.2l30.1,2.2l30.1,2.3l3.8,0.3l1.9,0.1h0.5h0.2c-0.1,0,0,0,0.1,0h0.1h0.9 l7.5,0.1l15.1,0.2l120.5,2.4l120.5-2.3l15.1-0.2l3.8-0.1h1.9h0.9l0.9-0.1l7.5-0.6l30.1-2.2l30.1-2.2l30.1-2.1h-0.1l34.3-9.1 l-34.1,9.9l0,0l0,0l-30,2.7l-30,2.6l-30,2.6l-7.5,0.6l-1,0.1h-0.9l-1.9,0.1L447,384l-15.1,0.4l-60.3,1.4l-30.1,0.7l-15.1,0.4 l-7.5,0.2l-3.8,0.1h-1.9h-0.9H312h-0.2h-0.5l-120.5-2.9l-15.1-0.4l-7.5-0.2h-0.9H167h-0.2h-0.5l-1.9-0.2l-3.8-0.3l-30-2.6l-30-2.7 l-30-2.7l0,0l0,0L37.7,365.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.3,420.5l16,6.9l16,6.9h-0.1c15.4,1.9,30.8,3.8,46.1,5.8l46.1,5.9h-0.1c11,0.4,22,0.7,33,1.1l33,1.2 l66,2.4h-0.1l66.4-2.3l33.2-1.2l16.6-0.6l16.6-0.5h-0.1l45.6-6l22.8-3l22.8-2.9H535l16.8-7l16.8-6.9l-16.6,7.4l-16.6,7.3l0,0h-0.1 l-22.7,3.4l-22.7,3.3l-45.5,6.6l0,0h-0.1l-16.6,0.7l-16.6,0.7l-33.2,1.3l-66.4,2.6h-0.1h-0.1l-66-2.7l-33-1.4 c-11-0.4-22-0.9-33-1.4h-0.1l0,0l-46-6.5c-15.3-2.1-30.7-4.4-46-6.6h-0.1H87l-15.9-7.3L55.3,420.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.5,471.5c9.1,4.6,18.1,9.3,27.2,14h-0.1l43,8.6l43,8.7h-0.1l29,1.4l28.8,1.5l57.9,3.1H313l56.4-3.1 l28.2-1.5l28.2-1.4h-0.2l43-9.2l43-9.1h-0.1c8.9-4.2,17.8-8.4,26.8-12.6c-8.8,4.5-17.6,8.9-26.4,13.3l0,0h-0.1l-42.9,9.8 l-42.9,9.7h-0.1h-0.1l-28.2,1.9l-28.2,1.7l-56.4,3.4h-0.1h-0.1l-57.9-3.4l-28.9-1.7l-28.9-1.9h-0.1h-0.1l-42.9-9.2l-42.9-9.3h-0.1 l0,0C102.3,481.5,93.4,476.5,84.5,471.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.4,512.7c3.8,2.9,7.7,5.8,11.5,8.7l11.5,8.8l-0.2-0.1l18.6,3.8l18.6,3.9l37.2,7.7h-0.2 c7.8,0.5,15.6,1,23.4,1.6l23.4,1.6l46.8,3.2h-0.2l45.6-3.6l22.8-1.8c7.6-0.6,15.2-1.2,22.8-1.8h-0.2l39.2-8.5l19.6-4.3l19.6-4.2 l0.1,0.1l10.5-7l10.5-7l-10.2,7.5l-10.2,7.4l-0.1,0.1h-0.1l-19.5,4.6l-19.6,4.5l-39.1,9.1h-0.1h-0.1c-7.6,0.7-15.2,1.3-22.8,2 l-22.8,1.9l-45.6,3.9h-0.1h-0.1l-46.8-3.5l-23.4-1.7c-7.8-0.6-15.6-1.1-23.4-1.8h-0.1H218l-37.1-8.3l-18.5-4.1l-18.5-4.2h-0.1 l-0.1-0.1l-11.2-9.2C128.8,518.8,125.1,515.8,121.4,512.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.5,577.8l-14.2-15.5l-14.2-15.5l0,0v-0.1l-10.8-21.2l-10.7-21.3v-0.1V504l-18.3-56.6v-0.1v-0.1 c-1.9-10.7-3.9-21.5-5.7-32.2l-5.7-32.2v-0.1v-0.1l-4.4-76.1v-0.1v-0.1l3.6-76.4v-0.1v-0.1l6.5-33.8l3.3-16.9l3.3-16.9V162v-0.1 l17.7-54.6v-0.1v-0.1l13-23l13.1-23l0,0l0,0L243.3,35l0.1-0.1h0.1l24.1-6.8l-24,7.4l0.1-0.1l-19.6,26.7v-0.1l-12.8,23.2 l-12.8,23.1l0.1-0.2l-17.3,54.8v-0.1l-3.1,16.9l-3.2,16.9l-6.4,33.8v-0.2l-3.3,76.4v-0.2l4.2,76.2v-0.2l5.6,32.2 c1.9,10.7,3.7,21.5,5.5,32.2v-0.2l17.6,56.8v-0.1l10.4,21.4l10.3,21.5l-0.1-0.1l13.9,15.8L246.5,577.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.6,531.2l-34.5-44.9l0,0v-0.1c-8.3-17-16.4-34.1-24.7-51.1V435v-0.1l-8.4-30l-8.4-30v-0.1v-0.1L63.3,307 v-0.1v-0.1l3.1-34.5l3.2-34.5v-0.1v-0.1L87,174.7v-0.1l0.1-0.1l27.5-50.3v-0.1l0.1-0.1l23.1-27.2L161,69.6l0.1-0.1h0.1l51.9-26.3 l-51.4,27.2l0.2-0.1l-22.8,27.5l-22.9,27.4l0.1-0.2l-27.2,50.5l0.1-0.2l-17.2,63v-0.2l-3.1,34.5l-3.2,34.5v-0.2l5.9,67.7v-0.2 l8.2,30.1l8.1,30.1l-0.1-0.1c8,17.1,16.1,34.2,24.1,51.4l-0.1-0.1L145.6,531.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.1,578l24.6-30.1v0.1l11.6-22.3l11.8-22.3l-0.1,0.1l17.6-56.8v0.2l2.7-16.2l2.8-16.1l5.6-32.2v0.2 l4.2-76.2v0.2l-3.3-76v0.2l-6.6-34.1c-2.2-11.4-4.4-22.8-6.5-34.2v0.1l-17.2-54.3l0.1,0.2l-12.6-23.1l-12.5-23.1l0.1,0.1 l-21.5-26.7l0.1,0.1l-22.2-7.6l22.4,7.1h0.1l0.1,0.1l21.9,26.3l0,0v0.1l12.9,22.9l12.8,22.9v0.1v0.1l17.6,54.2v0.1v0.1 c2.3,11.4,4.6,22.7,6.8,34.1l6.8,34.1v0.1v0.1l3.6,76v0.1v0.1l-4.4,76.1v0.1v0.1l-5.7,32.2l-2.8,16.1l-2.9,16.1v0.1v0.1 l-18.3,56.6v0.1v0.1l-12.1,22.1l-12.3,21.7l0,0l0,0L377.1,578z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "481.6,528.2 511.3,484.6 511.3,484.8 523.2,459.5 535.3,434.4 535.2,434.5 543.3,404.5 551.5,374.5  551.5,374.5 557.5,306.9 557.5,307 554.2,272.5 551.2,237.9 551.2,238.1 535.2,175.2 535.2,175.6 509.2,126.2 509.4,126.2  485.3,98.3 461.3,70.3 461.4,70.4 410.4,43.3 461.9,69.6 462,69.7 462,69.7 486.4,97.3 510.8,125.1 510.8,125.2 510.9,125.2  537.2,174.6 537.2,174.6 537.2,174.8 553.5,237.6 553.5,237.6 553.5,237.8 556.8,272.2 559.8,306.9 559.8,307 559.8,307  553.7,374.8 553.7,374.9 553.7,375 545.2,405 536.8,435 536.8,435 536.8,435.1 524.5,460.1 512.2,485.1 512,485.2 512,485.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.9,586.5c0,0-0.1-8.8-0.3-24.1c-0.1-7.7-0.2-17-0.3-27.7c-0.1-10.7-0.2-22.8-0.3-35.9 c-0.1-13.2-0.2-27.4-0.2-42.5c-0.1-15.1-0.2-31-0.2-47.4c-0.1-32.9-0.1-68-0.2-103.1c0.1-35.1,0.1-70.2,0.2-103.1 c0-16.4,0.1-32.3,0.2-47.4c0.1-15.1,0.2-29.3,0.2-42.5c0.1-13.2,0.2-25.2,0.3-35.9c0.1-10.7,0.2-20,0.3-27.7 c0.2-15.4,0.3-24.1,0.3-24.1s0.1,8.8,0.3,24.1c0.1,7.7,0.2,17,0.3,27.7c0.1,10.7,0.2,22.8,0.3,35.9c0.1,13.2,0.2,27.4,0.2,42.5 c0.1,15.1,0.2,31,0.2,47.4c0.1,32.9,0.1,68,0.2,103.1c-0.1,35.1-0.1,70.2-0.2,103.1c0,16.4-0.1,32.3-0.2,47.4s-0.2,29.3-0.2,42.5 c-0.1,13.2-0.2,25.2-0.3,35.9c-0.1,10.7-0.2,20-0.3,27.7C313,577.8,312.9,586.5,312.9,586.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "left_globe_1_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.5,
    y1: 312.1,
    x2: 593.9,
    y2: 312.1,
    gradientTransform: "matrix(1 0 0 -1 0 618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E43C29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 312.7,
    cy: 305.9,
    rx: 281.2,
    ry: 280
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "587.4,248.5 574.1,256.2 555.5,259.4 526.5,262.8 460.9,267.3 313.4,270.6 162.9,267.2 97.4,262.5  52,256 38.6,247.7  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "570.6,193.7 559.1,203.2 515.9,214.3 451.6,222.2 313.4,227.6 170.1,221.8 109.6,214.1 66.8,202.8  56.2,191.2  "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "542.6,143.6 528.4,162.6 497.5,174.2 443.8,184.5 312.9,192.6 182.4,184.6 96.8,162.1 84.6,141.9  "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "505.7,101.1 502,122.4 439.3,143.7 314,157.6 185.7,143.7 125.4,121.9 120.3,101.8  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.9,57.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M594.9,307.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.9,307.1"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "159.9,70.1 166.4,88.6 220.3,113.7 313.1,124.5 406.2,113.6 460.4,87.1 466.4,69.6  "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "211.7,45.7 211.7,61.1 247.4,83.6 314,91.5 377.9,83.1 413.4,61.1 413.4,45.9  "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "364,46.6 362.5,40.1 342.4,30.9 312.9,29 283.6,30.8 264.7,39.6 261.7,46.5 267.9,52.8 280.2,58.9  295.5,61.1 313.1,62.5 331,61.1 346.9,57.9 359.2,53.3  "
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "586.9,366.2 572.9,358.4 554.8,355 525.8,351.7 460.2,347.2 312.7,343.9 162.2,347.4 96.7,352  51.4,358.5 38.7,366.6  "
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "569.7,421.3 558.1,408.3 515,397.3 450.7,389.5 312.7,386.5 169.2,389.9 108.7,397.5 70.1,407.6  56.3,421.3  "
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "539.3,472.7 527.7,451 496.8,439.6 443.1,429.3 312.2,421.3 181.7,429.2 96.1,451.6 85.5,472.3  "
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "503.3,512.4 501.3,490.9 438.6,469.8 313.3,456 185.1,469.8 124.8,491.4 122.4,513.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "460.3,527.3 460.3,543.9 412.7,566.3 384.6,570.9 313,574.1 241.7,570.5 211,566.1 160.8,542.2  164.9,528.4 186.3,511.8 219.7,499.5 312.4,488.8 405.6,499.6 440.4,511.8  "
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "211,566.9 211,551.7 246.7,529.3 313.3,521.6 377.2,529.8 412.7,551.7 412.7,566.8  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M279.5,27.9l33.3,14.2l13.7,15.4l27.3,45.9l19.5,58l12.1,65.9c0,0,4.8,52.2,4.8,80c0,13-1.1,38.4-1.1,38.4 l-3.6,41.3c0,0-3.6,26.1-6,38.5c-2.5,12.9-8.5,36.9-8.5,36.9l-10.3,32.1L346.9,526l-18.2,29.5L313,574.1l-47.2,8.4"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "262.5,30.9 312.9,42.1 348.2,57.4 399.8,105.6 434.7,165 455.5,230.7 463.4,307.7 461.3,347.3  454.4,389.9 443.1,429.3 426.2,468.4 406.9,500.2 377.2,529.8 349.6,554.6 313,574.1 290.2,584.9  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M345.6,27.9l-33.4,14.2l-13.7,15.4l-27.3,45.9l-19.5,58l-12.1,65.9c0,0-4.8,52.2-4.8,80 c0,13,1.1,38.4,1.1,38.4l3.6,41.3c0,0,3.6,26.1,6,38.5c2.5,12.9,8.5,36.9,8.5,36.9l10.3,32.1l13.8,31.5l18.9,29.6l15.8,18.7 l43.7,8.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.9,29.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.9,587.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "578.9,307.4 571.7,372.1 558.1,408.3 532.8,457.3 501.3,490.9 460.3,527.3 413.2,553.1 361.5,568.1  313,574.1 260.1,558.4 212.1,532.4 186.3,511.8 174,501.4 128.6,442.5 104.3,379.3 95.4,307.4 98.8,262.6 109.7,216.7 129.2,171.2  154.6,132.4 187,98.3 226.2,70.3 267.1,52 312.4,42 364,46.6 413.4,61.1 460.4,87.1 502,122.4 532.3,157.6 558.8,205.7  574.3,255.7  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "46.4,309 54.1,370.3 80.7,432.2 93.2,456 121.3,489.8 164.9,528.4 211,551.7 262.7,567.3 313,574.1  365.4,558.4 409.9,536 440.4,511.8 451.9,501.1 496.6,444.1 521,380.9 529.9,309 526.5,264.2 515.5,218.3 496,172.8 470.6,134.1  438.2,99.9 399,71.9 358.1,53.6 312.9,42.1 258.3,44.3 211.7,61.1 166.4,88.6 125.1,118.8 93.9,157.6 66.4,207.3 50.9,257.3  "
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "363.7,30.9 316.9,41.1 312.3,42.1 276.9,57.4 225.3,105.6 190.4,165 169.6,230.7 161.7,307.7  163.7,347.3 170.7,389.9 182,429.3 198.9,468.4 218.2,500.2 246.7,529.3 275.7,554.7 313,574.1 334.7,584.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.5,
      enableBackground: "new"
    },
    width: 1779,
    height: 2200,
    xlinkHref: "FD8171C0437A61F8.png",
    transform: "matrix(0.2395 0 0 0.2395 130.4602 42.6035)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M342.7,406.9c46.3,11.5,92.7,22.6,139.2,32.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M338,403.3c47.8-15.7,95.5-31.8,143.2-47.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.1,401.1c53.5-12.4,106.8-25.3,160-38.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M489.8,422.9c-57.3-4.1-114.5-9-171.7-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M509.8,441.9c-56.2-10.8-112.2-22.6-168-35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M456.2,469.1c-38.1-20.2-75.9-41.1-113.5-62.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c61.5,0.2,123-0.2,184.5-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c51,12.3,102.2,24.3,153.6,35.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c45.3-3.6,90.6-7.4,135.9-11.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c18.1,48.9,36.3,97.7,55.2,146.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c-17.1,50-34.5,100-52.5,149.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337,411.2c-2.3,43.2-4.6,86.4-7,129.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,406.9c-4.4,52.2-8.9,104.3-13.6,156.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M334.4,406.7C314,308.6,294,210.4,272.3,112.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.1,405.3c28.7-54.4,57.1-109,85.9-163"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c66.2-11.1,132.3-22.8,198.2-34.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c62.3-23.4,124.3-47.4,186.3-70.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c65.4-18.4,130.5-37.5,195.6-56.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c56-25.9,111.6-52.4,167.3-78.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c47.9,28.9,96.2,57.5,145.1,84.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c37.2,38.1,74.6,76.1,112.9,113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c44.5,35.4,89.3,70.5,135.1,104.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.1,405.3c30.2,43.8,60.6,87.5,91.9,130.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c20.5,40,41.2,79.9,62.4,119.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337,405.3c6.2,37.3,12.5,74.6,18.9,111.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337,405.3c2,52.7,3.9,105.4,6,158.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337,405.3c-27.2,49.2-54.8,98.3-83.3,146.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,406.9c-34,45.8-68.3,91.4-103.7,135.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c35.2,118.8,65.8,240.3,96.7,362.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259.5,488.9c5.7-125.2,9.7-250.5,12.8-376"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.2,73.1c-12.7,138.9-25.4,277.6-40.7,415.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.6,59.1c-4.1,13.1-8.2,26.3-12.3,39.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c-3.8-13.2-7.6-26.3-11.5-39.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c18.3-4.8,36.7-9.4,55.1-13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c30.5,11.3,60.9,23,91.2,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.9,129.8c30.2,127.6,58.8,255.5,90.7,382"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M442.6,482.2c-35.5-115.6-68-232.9-102.1-349.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,216.3c48.5-39.2,97.2-78.9,146.8-117.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c66.9,129.3,127.3,263.2,192.3,394"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.2,73.1c8.3,38.4,16.3,76.8,24.2,115.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M304.3,135.9C343.7,248.2,381,361.4,421,473.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c14.2,29.7,28.1,59.7,41.8,90"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,216.3c40.6,72.6,79.8,146.8,119.8,220.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,216.3c62.1,17.5,123.9,36.1,185.7,54.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209,217.6c34.8,22.9,69.3,46.3,103.8,69.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,216.3c33.8,15,67.5,30.4,101.1,45.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.7,321.1c-43.1,27.1-86.2,54.7-129.6,81.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M485.8,321c-48.9,26.5-97.7,53.5-146.7,80.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M527.2,384.8C463.9,392,400.5,399,337,405.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M527.5,409.8c-62.9-0.8-125.7-2.3-188.5-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M510.7,419.6c-57.3-4-114.5-8.9-171.6-14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M493,461c-51.7-17.6-102.9-36.4-154-55.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M501.1,471.4c-54.5-20.9-108.4-43.3-162-66.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M307.5,563.2c9.7-51.5,19-103,28.2-154.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M307.7,536.6c9.5-42.6,18.8-85.3,28-128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.1,552.9c11.7-46.6,23-93.2,34.2-140"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.3,562.8c19.8-52.2,38.9-104.8,57.7-157.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.3,519.6c11.3-33.8,22.3-67.6,33.3-101.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.9,440.3c-59.5-10.7-118.8-22.5-177.8-35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M466.5,441.4c-42.6-11.5-85.1-23.7-127.4-36.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M370.1,555.9c-10.6-50.1-20.9-100.4-31-150.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M354.5,563.4c-5.7-51.1-11.3-102.3-16.8-153.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M436.9,530.4c-33.3-41.1-65.7-83-97.8-125"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M447.3,326.1c-36,24.9-72,50-108.2,75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M420.2,335.9c-27,21.7-54,43.5-81.1,65.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M343,399.8c19.4-19.2,38.7-38.5,58-57.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M493.7,493.5c-52.2-28.2-103.6-58-154.6-88.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M440,518.7c-60.4-8.7-120.6-18.8-180.5-29.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M430.6,511.8c-57.2-6.5-114.3-14.3-171.1-22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M440,518.7c-34.2-37.2-67.7-75.2-100.9-113.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M420.6,536c-28.5-43.1-56.2-86.8-83.6-130.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M404,549.1c-22.2-45.8-43.7-91.9-64.9-138.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M384.9,519.6c-16.2-38-32.1-76.1-47.9-114.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M372.5,525.9C360.1,485,348.1,444,336.1,403"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361,544.4c-7.5-44.4-14.7-88.9-21.9-133.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.7,525.5c19.5-39.8,38.5-80,57.3-120.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263,548.7c24.8-46.3,48.9-93.2,72.7-140.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253.9,535.7c29-44.4,57.2-89.4,85.1-134.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.1,500.3c26.7-29.5,53-59.5,79.1-89.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M223.6,529.7c38.3-39.4,75.7-80,112.6-120.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M223.8,515.6c39.1-36,77.3-73,115.2-110.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M224.1,499.6c36.8-29.2,73.1-59.3,109.1-89.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.4,483.2c34.4-24.6,68.4-49.9,102.2-75.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.7,468.1c32.4-20,64.5-40.5,96.4-61.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M220.4,514.7c38.6-34.5,76.4-70,113.9-105.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M249.4,454.8c29.4-16.2,58.5-32.8,87.6-49.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264.7,441.2c23.3-11.6,46.5-23.3,69.6-35.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M273.7,430.1c20.3-7.9,40.5-15.9,60.6-24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M288.2,416.4c15.4-3.4,30.7-6.9,46.1-10.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M340.6,408.9c14.1,21.9,28.3,43.8,42.6,65.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M417.2,477.2c-24.3-21.7-48.4-43.7-72.3-65.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M442.3,481.3C408.5,457,375,432,341.7,406.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M368.4,66c-5.7,10.8-11.3,21.7-17,32.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M388.9,68.7c-12.5,9.7-24.9,19.6-37.3,29.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.8,68.3c-16.6,9.6-33.1,19.4-49.5,29.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352.7,98.5c25.2-1.8,50.5-3.4,75.8-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352.7,98.5c21.9,1.6,43.7,3.4,65.6,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.1,98.1c31,4,62,8.4,92.9,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.1,98.1c29,7.1,57.9,14.5,86.7,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M349.4,61.5c0.8,12.2,1.5,24.4,2.3,36.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327.2,57.6c8.1,13.6,16.2,27.3,24.2,41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.5,63.6c8.7,11.6,17.3,23.3,25.9,35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.5,70.6c8.7,9.3,17.3,18.6,25.8,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c34.9,17.8,69.6,36.1,104,54.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c36.9,22.8,73.4,46.1,109.7,69.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c7.8,11.3,15.6,22.6,23.3,33.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c17.5,16.7,34.8,33.4,52,50.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.4,98.5c24.1,18.2,48.1,36.5,71.9,54.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c17.6-7.6,35.3-15.1,53-22.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c16.6-8.9,33.3-17.8,50.1-26.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c15-9.6,30.1-19.2,45.2-28.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c10.7-8.2,21.4-16.4,32.1-24.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c8.7-8.2,17.5-16.3,26.2-24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c5.5-7.7,11-15.4,16.5-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.6,57.9c-2.3,5.6-4.7,11.1-7,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-0.1-5.1-0.2-10.2-0.3-15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-4.1-4.5-8.3-8.9-12.4-13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-5-3.4-10.1-6.8-15.2-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-8.5-2.3-17-4.6-25.6-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-11.5-0.5-22.9-0.9-34.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-24.4,3.8-48.7,7.8-73,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-19.3,4.9-38.5,9.9-57.6,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c-22.4,8.2-44.7,16.5-67,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.8,109.4c24.5-11.7,49.1-23.3,73.8-34.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M161,112.2c22.1-12.6,44.3-25.2,66.6-37.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.2,107c15.8-10.6,31.6-21.3,47.5-31.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c7.1-4.2,14.2-8.5,21.3-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c6.6-6,13.2-12,19.8-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c5.4-6.5,10.9-12.9,16.3-19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c4.7-7.5,9.4-14.9,14.1-22.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c-0.6-4.7-1.2-9.4-1.8-14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c-2.5-4.2-4.9-8.4-7.4-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c-4.4-3.4-8.7-6.7-13.1-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c-5.2-2.3-10.3-4.7-15.5-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c-9.3,0.3-18.5,0.7-27.8,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c-8.9,1.6-17.7,3.2-26.5,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c-8.8,2.8-17.6,5.6-26.4,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c2.3-6.3,4.5-12.7,6.8-19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.7,147.6c8.7-7.1,17.4-14.1,26.1-21.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.9,144.3c6.3-6,12.6-11.9,18.9-17.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.2,121.8c5.9,1.5,11.7,3.1,17.6,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M303.3,57.7c24.1,24.7,47.8,49.6,71.4,74.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.2,58c29.5,24.5,58.6,49.4,87.5,74.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.9,68.1c15.5,22.4,30.9,45,46.1,67.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293.5,63.2c6.8,61.1,13.1,122.3,19.3,183.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293.5,63.2c-7.1,17.2-14.2,34.4-21.3,51.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M295,76.6c-7.6,12.1-15.2,24.2-22.7,36.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c75.3,39.9,148.7,83.1,221.6,126.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c28.2,22.4,56,45.3,83.5,68.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.2,200.7c-45.8-19.5-91.8-38.9-138.1-57.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.1,143c9.6-4.4,19.2-8.9,28.9-13.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327.4,149.7c4.2-6.6,8.4-13.3,12.6-19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M315.7,146.4c7.6-5.3,15.2-10.5,22.8-15.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.3,112.9c29.6,2.2,59.1,4.8,88.6,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.3,112.9c-21.8,33.8-43.3,67.6-64.9,101.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M271.8,131.1c-21.6,27.7-43,55.4-64.4,82.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c25.6,56.1,50.1,112.9,74.2,169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c56.9,91.9,109.9,187.9,163.9,283.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.8,126.4c51.7,93.3,99.7,190.1,148.4,286.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,216.3C248.4,278.6,291,342.4,334.3,406"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.9,188.4c22.1,27.5,44,55.1,65.9,82.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M430.8,223.9c-13.6,15.6-27,31.3-40.5,47.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.2,200.7c-8.1,13.8-16.2,27.7-24.2,41.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.2,200.7c-6.2,7.7-12.3,15.5-18.4,23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.4,217.6c29.4-2.2,58.9-4.3,88.3-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M520.6,401.8C444.8,340.2,370.9,275,295.8,211.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424.6,231c-42.9-6.8-85.9-13.4-128.9-19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M390.3,271c25.1,16.8,50.2,33.5,75.4,50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M390.3,271c10,21.7,19.9,43.3,29.9,64.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,216.3c46.7-36.3,93.5-73,141.1-109"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209,214c46.3-34.7,92.7-69.7,139.8-104.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M406.5,84.7c-5.8,62.1-11.1,124.2-16.2,186.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.8,68.3c-4.3,66.6-8.3,133.3-11.9,200"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M388.9,68.7c-0.3,67.5-0.3,134.9-0.2,202.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389.8,268.3c-0.4,0.9-0.7,1.8-1.1,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M387.2,174.5c-18,77-35.3,154.3-52.9,231.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M388.9,68.7c-44.5,139.7-84.8,281.1-129.4,420.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M390.3,271c0.5,26.7,0.9,53.5,1.5,80.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389.8,269.7c-2.6,13.6-5.2,27.2-7.8,40.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.2,200.7c-7.4,103.5-13.3,207.2-18.5,311.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.2,200.7c6,102.5,13.1,204.7,22,306.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.9,405.2c10.4,0.3,20.7,0.6,31.1,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M317.3,393.2c5.7,4.3,11.3,8.6,17,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.3,401.1c3.2,1.7,6.5,3.3,9.7,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259.5,488.9c23.9-112.5,45.5-225.8,67.9-339.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M333.9,404.1c-3.8-73.5-7.7-147-11.7-220.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M281.9,156.2c26.4,77,51.8,154.6,77.6,232"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M284.1,155.1c34.4,81.6,67.5,164,101.4,245.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424.6,231c-32.8-35.8-65.6-71.9-98.9-107.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424.6,231c-38.9-30.5-77.9-61.1-117.4-91.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.3,96.8c26.1,5.1,52.1,10.5,78,16.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259.5,488.9C278,374.1,294.4,258.6,311.1,143"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.1,223.7c11.4,60.1,22.6,120.2,33.8,180.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M333.9,404.1c-3.6-40-7.3-80-11-120"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M333.9,404.1c-1.8-66.3-3.6-132.5-5.5-198.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M336.1,403c-3.4-70.3-6.8-140.6-10.3-210.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M340.6,132.4c-0.5,89.6-1,179.2-1.5,268.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M419,465.1c-31.8-83-62.2-166.8-93.2-250.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.3,112.9c21.3,98.9,40.9,198.3,60.9,297.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.6,74.6c70.7,143.6,133.6,292.6,203.1,437.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.3,253c30.8,79.6,61.3,159.4,93.3,238.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M281.9,156.2c48.4,114.4,94,230.4,143.2,344.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.4,217.6c59.7-14.8,119.6-29.4,179.8-43.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.7,123.5c41.5,25.4,82.6,51.3,123.5,77.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M304.3,135.9c0.5,28.4,0.9,56.8,1.3,85.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M304.3,135.9c1.7,33.6,3.4,67.3,4.9,100.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.8,485.9c15.8-133.4,29.2-267.4,42.6-401.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.8,69.3c-12.6,133.4-25.2,266.5-40,399.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.4,75.7c2,21.4,4,42.8,5.9,64.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.8,69.3c2.8,22.4,5.5,44.8,8.1,67.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M308.9,136.6c17.3-5.4,34.6-10.8,51.9-16.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M281.9,156.2c26.2-12.1,52.5-24,78.9-35.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M291,146.5c23.2-8.8,46.5-17.5,69.9-26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M307.3,139.8c40,118.4,77.7,237.7,118.7,355.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.6,138.6c38.2,120.6,74.3,242,113.6,361.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M388.7,271c-18.1,45.2-36.1,90.5-54.3,135.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.2,200.7c-19.7,30.5-39.2,61.3-58.5,92.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M390.7,292.8c-17.7,38-35.4,76.1-53.2,114.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M447.3,326.1c0.4-41.8,1-83.7,1.9-125.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M420.2,335.9c9.5-45.2,19-90.3,29-135.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M400.9,342.1c15.9-47.3,31.9-94.5,48.3-141.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M391,272.7c18.8-23.5,37.6-46.9,56.7-70.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M390.3,271c-17.5,44-34.8,88.1-52.3,132.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,216.3c65.9-23,132.1-46,198.8-67.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.7,321.1c15.6-33.2,31.4-66.1,47.4-98.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M388.7,271c51.4-5.9,102.9-11.6,154.3-16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424.6,231c38.7,7.7,77.4,15.6,116,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M411.6,310.5c38.4-22,76.8-43.7,115.4-64.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M504.8,219.9c4.5,2.3,9.1,4.5,13.6,6.8c0.1-5.4,0.1-10.7,0.2-16.1C514,213.6,509.4,216.7,504.8,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M522.6,241.1c1.4,3.5,2.9,7.1,4.3,10.6c3-3.5,5.9-7,8.9-10.4C531.5,241.2,527.1,241.1,522.6,241.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M535.8,248.5c0,4-0.1,8-0.1,12c4.9-2,9.8-4,14.7-6C545.5,252.5,540.7,250.5,535.8,248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M441.8,202.5c3-3.2,6-6.5,8.9-9.7c0.2,1.1,0.3,2.3,0.5,3.4c0.5,3.2,0.9,6.5,1.4,9.7 C449,204.8,445.4,203.6,441.8,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M464.2,193c-1.2,4.4-2.3,8.7-3.5,13.1c-3.1-2.9-6.2-5.8-9.3-8.7C455.7,195.9,460,194.4,464.2,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M483.9,319.5c0.6,1.3,1.3,2.7,1.9,4c1-1.3,1.9-2.6,2.9-3.8C487.1,319.6,485.5,319.5,483.9,319.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M499.5,323.4c0.9,1.6,1.8,3.2,2.7,4.7c1.5-2.3,2.9-4.5,4.4-6.8C504.2,322.1,501.8,322.7,499.5,323.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M520,329.6c0.4,1.9,0.9,3.9,1.3,5.8c1.8-1.9,3.7-3.9,5.5-5.8C524.5,329.6,522.2,329.6,520,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M529.1,344.4c0.5,1.5,1,3,1.5,4.5c1.7-1.2,3.4-2.4,5.1-3.6C533.5,345.1,531.3,344.7,529.1,344.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M479.6,354c0.5,1.7,1,3.3,1.5,5c1.6-1.7,3.2-3.3,4.8-5C483.8,354,481.7,354,479.6,354z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M497.5,361.3c0.4,1.4,0.8,2.8,1.1,4.2c1.3-0.9,2.7-1.8,4-2.7C500.9,362.4,499.2,361.8,497.5,361.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M532.6,366.6c0.4,1.5,0.8,3,1.3,4.5c1.1-1.3,2.2-2.6,3.3-3.8C535.6,367,534.1,366.8,532.6,366.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M526,382.8c0.2,1.6,0.4,3.3,0.7,4.9c1.3-1,2.7-2,4-3C529.1,384.1,527.6,383.4,526,382.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M520.5,397c-1.1,2.7-2.3,5.3-3.4,8c3.1-0.3,6.1-0.6,9.2-0.9C524.4,401.8,522.4,399.4,520.5,397z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M526.3,407.5c0,1.7,0,3.4,0.1,5c1.5-0.9,3.1-1.8,4.6-2.7C529.4,409,527.9,408.2,526.3,407.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M509.9,416.4c-0.1,2.4-0.3,4.8-0.4,7.3c1.7-1.2,3.4-2.5,5.1-3.7C513.1,418.7,511.5,417.5,509.9,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M488.5,420.1c0,2.1,0.1,4.2,0.1,6.4c2.1-0.8,4.2-1.7,6.3-2.5C492.8,422.6,490.7,421.3,488.5,420.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M514.9,436.8c-0.3,2.3-0.7,4.6-1,7c2.8-0.9,5.6-1.7,8.4-2.6C519.8,439.7,517.4,438.3,514.9,436.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M508.8,439.6c-0.4,1.9-0.8,3.7-1.1,5.6c2.1-0.7,4.2-1.4,6.2-2.1C512.2,442,510.5,440.8,508.8,439.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M488.7,435.2c-0.6,2-1.3,3.9-1.9,5.9c2.5-0.3,5-0.7,7.5-1C492.5,438.4,490.6,436.8,488.7,435.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M481.4,436.6c-0.7,2-1.3,4-2,6c2.5-0.1,5-0.1,7.4-0.2C485,440.5,483.2,438.5,481.4,436.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M466.5,438.5c-0.9,1.6-1.7,3.2-2.6,4.9c2.4,0.2,4.8,0.5,7.3,0.7C469.6,442.3,468,440.4,466.5,438.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M493,458.2c-0.7,1.7-1.4,3.3-2,5c2.3-0.1,4.6-0.1,6.9-0.2C496.2,461.4,494.6,459.8,493,458.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M501.1,468.8c-0.7,1.7-1.4,3.5-2.1,5.2c1.7-0.2,3.4-0.5,5.2-0.7C503.1,471.7,502.1,470.2,501.1,468.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M457.6,465c-0.8,2-1.7,3.9-2.5,5.9c1.7,0,3.4-0.1,5.1-0.1C459.3,468.9,458.4,466.9,457.6,465z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M481.1,484.1c-1,2-2,3.9-3.1,5.9c1.9-0.1,3.9-0.1,5.8-0.2C483,487.9,482.1,486,481.1,484.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M493.6,490.2c-1,1.6-1.9,3.2-2.9,4.8c1.8,0.3,3.7,0.6,5.5,1C495.4,494.1,494.5,492.2,493.6,490.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M445.6,479.2c-2,1-4.1,2-6.1,3c1.6,1.1,3.2,2.2,4.8,3.4C444.7,483.5,445.1,481.4,445.6,479.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M467.6,507.3c2.3-1.1,4.6-2.2,7-3.3c-0.3,2.6-0.5,5.3-0.8,7.9C471.7,510.4,469.6,508.9,467.6,507.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M423.6,493.3c2-0.5,4-1,6-1.5c-0.8,2.3-1.6,4.6-2.4,6.9C426.1,496.9,424.9,495.1,423.6,493.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M426.5,509.1c2.6-0.6,5.2-1.1,7.9-1.7c-0.7,2.5-1.5,5-2.2,7.4C430.2,512.9,428.3,511,426.5,509.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M446.1,517.1c1.5-1.4,2.9-2.7,4.3-4.1c0.5,2,0.9,4.1,1.4,6.1C450,518.4,448,517.8,446.1,517.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M379.2,474.4c1.8-1,3.6-2,5.4-3c0,1.7,0,3.5,0,5.2C382.8,475.9,381,475.2,379.2,474.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M436.7,521.1c1.5-1.7,3-3.3,4.4-5c0.7,2.2,1.3,4.5,2,6.7C441,522.3,438.9,521.7,436.7,521.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M434.7,531.8c1.3-1.2,2.6-2.4,3.8-3.5c0,1.9,0.1,3.7,0.1,5.6C437.3,533.1,436,532.5,434.7,531.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M428.7,535.8c1.3-0.6,2.6-1.2,4-1.8c0,1.2,0,2.5,0.1,3.7C431.3,537.1,430,536.4,428.7,535.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M418.7,536.1c1-0.8,2-1.7,3-2.5c0,1.4,0,2.9,0.1,4.3C420.7,537.3,419.7,536.7,418.7,536.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M396.7,522.6c1.1-0.8,2.1-1.5,3.2-2.3c0,1.1,0,2.3,0,3.4C398.8,523.3,397.8,522.9,396.7,522.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M382.8,519.6c1.2-0.6,2.5-1.2,3.7-1.8c-0.2,1.2-0.4,2.4-0.6,3.6C384.9,520.8,383.8,520.2,382.8,519.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.7,549.6c1.4-0.7,2.7-1.5,4.1-2.2c-0.3,1.2-0.5,2.4-0.8,3.6C403.9,550.5,402.8,550.1,401.7,549.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389,549.4c1.3-0.6,2.5-1.2,3.8-1.8c-0.2,1-0.5,2.1-0.7,3.1C391.1,550.2,390,549.8,389,549.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M369.9,525.9c1.4-0.6,2.9-1.3,4.3-1.9c-0.5,1.1-1.1,2.2-1.6,3.3C371.7,526.8,370.8,526.4,369.9,525.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M354.2,517.2c1.2-0.3,2.4-0.6,3.5-0.9c-0.6,1.1-1.3,2.3-1.9,3.4C355.3,518.9,354.8,518.1,354.2,517.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M359.4,544.4c1.1-0.3,2.3-0.5,3.4-0.8c-0.6,0.8-1.1,1.5-1.7,2.3C360.6,545.4,360,544.9,359.4,544.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M368.5,555.9c1-0.3,2-0.7,3-1c-0.3,0.9-0.6,1.8-0.9,2.7C369.9,557.1,369.2,556.5,368.5,555.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352.7,563.4c1.1,0,2.1,0,3.2,0c-0.5,0.7-0.9,1.3-1.4,2C354,564.7,353.3,564,352.7,563.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M341.7,562.9c0.9,0,1.8,0,2.7,0c-0.4,0.8-0.9,1.6-1.3,2.4C342.6,564.5,342.2,563.7,341.7,562.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M328.6,540.8c1.1,0,2.2,0,3.2,0c-0.5,0.6-1.1,1.3-1.6,1.9C329.7,542.1,329.1,541.5,328.6,540.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M320.5,562.8c1.2,0.2,2.3,0.3,3.5,0.5c-0.5,0.3-1,0.6-1.5,1C321.8,563.8,321.2,563.3,320.5,562.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.7,562.1c1,0.4,2,0.8,3,1.2c-1,0.2-2,0.5-3,0.7C306.7,563.3,306.7,562.7,306.7,562.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306,535.7c1.3,0.3,2.6,0.6,3.9,0.9c-1,0.3-2,0.5-3,0.8C306.6,536.8,306.3,536.2,306,535.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.8,551.9c1,0.3,2.1,0.7,3.1,1c-1,0.3-2.1,0.5-3.1,0.8C298.8,553.1,298.8,552.5,298.8,551.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.9,551.6c1,0.3,2.1,0.6,3.1,0.9c-0.8,0.3-1.6,0.6-2.4,0.9C283.4,552.8,283.1,552.2,282.9,551.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277.9,561.7c1,0.2,2,0.5,3,0.7c-1,0.8-2,1.6-3,2.4C277.9,563.7,277.9,562.7,277.9,561.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M299,518.8c1,0,2.1,0,3.1,0c-1,0.8-2.1,1.7-3.1,2.5C299,520.6,299,519.7,299,518.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M278.4,524.7c1.2,0.3,2.5,0.5,3.7,0.8c-1.2,0.5-2.5,0.9-3.7,1.4C278.3,526.2,278.3,525.4,278.4,524.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M261.5,547.7c1.2,0.3,2.5,0.6,3.7,1c-1,0.5-2.1,1-3.1,1.5C261.9,549.3,261.7,548.5,261.5,547.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.9,551c1.2,0.3,2.4,0.7,3.6,1c-1,0.7-2.1,1.3-3.2,2C252.2,553,252,552,251.9,551z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.1,534.8c1.2,0.3,2.4,0.6,3.6,0.9c-1.2,0.2-2.4,0.5-3.6,0.7C252.1,535.9,252.1,535.4,252.1,534.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.1,487.2c1,1.1,2,2.2,2.9,3.3c-1.6,0.7-3.2,1.5-4.7,2.2C256.9,490.9,257.5,489,258.1,487.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253,499c1.1,0.8,2.1,1.6,3.2,2.4c-1.1,0.2-2.2,0.3-3.2,0.4C253,500.9,253,499.9,253,499z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222.4,527.6c0.1,0,0.1,0.1,0.2,0.1c1.1,0.7,2.3,1.4,3.4,2.1c-1.2,0.5-2.4,0.9-3.6,1.4 C222.4,529.9,222.4,528.7,222.4,527.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M231.1,542.1c1.3,0.3,2.6,0.6,4,0.9c-1.3,0.5-2.7,1-4,1.4C231.1,543.6,231.1,542.8,231.1,542.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222.7,514.7c1.2,0.3,2.4,0.6,3.6,0.9c-1.2,0.2-2.4,0.5-3.6,0.7C222.7,515.8,222.7,515.3,222.7,514.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M219.2,514c1,0.2,2,0.5,3,0.7c-1.2,0.2-2.3,0.5-3.5,0.8C218.9,515,219.1,514.5,219.2,514z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222.5,498.3c1.1,0.5,2.2,1,3.3,1.5c-1,0.4-1.9,0.9-2.9,1.3C222.8,500.2,222.6,499.2,222.5,498.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.6,482c0.8,0.4,1.6,0.8,2.4,1.2c-0.8,0.5-1.7,1-2.5,1.6C232.6,483.8,232.6,482.9,232.6,482z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238.6,466.8c1,0.8,2,1.6,2.9,2.4c-1,0-2,0-3,0.1C238.6,468.5,238.6,467.7,238.6,466.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248.1,453.6c1,0.6,1.9,1.1,2.9,1.7c-1,0.4-2,0.8-2.9,1.1C248.1,455.5,248.1,454.6,248.1,453.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264.9,439c0.6,1.2,1.3,2.4,1.9,3.6c-1.3,0-2.5,0-3.8,0C263.7,441.4,264.3,440.2,264.9,439z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M273.7,428.7c0.3,0.8,0.6,1.6,0.9,2.4c-0.6,0-1.2,0-1.8,0C273.1,430.3,273.4,429.5,273.7,428.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M288.2,415.4c0.3,0.9,0.5,1.7,0.8,2.6c-0.7-0.5-1.4-1-2.1-1.5C287.4,416.1,287.8,415.7,288.2,415.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.9,404c0.2,0.9,0.4,1.8,0.6,2.6c-0.8-0.5-1.6-0.9-2.4-1.4C299.7,404.8,300.3,404.4,300.9,404z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M318.2,407.7c0,1,0,1.9,0,2.9c-0.4-0.7-0.8-1.4-1.2-2.1C317.4,408.2,317.8,408,318.2,407.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.9,399.8c0.1,1.3,0.1,2.5,0.2,3.8c-0.7-1-1.5-1.9-2.2-2.9C321.6,400.4,322.2,400.1,322.9,399.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M411.6,310.5c33.7-29.8,67.4-59.3,101.5-88.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M340.8,404.8c38.4-68.4,76.2-137,115.2-204.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M388.7,271c29.2-13.4,58.5-26.6,87.9-39.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M411.6,310.5c14.6-36.8,29.4-73.5,44.4-110"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424.6,231c28.9,13.9,57.7,27.8,86.6,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M473.2,226c1.1,3.8,2.2,7.6,3.3,11.4c3.2-3.1,6.4-6.2,9.5-9.2C481.8,227.5,477.5,226.8,473.2,226z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M511.3,267.3c-1.6,3.5-3.1,7-4.7,10.5c3.8,0,7.6,0,11.5,0.1C515.8,274.4,513.5,270.9,511.3,267.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M493.4,264c-2.8-1.3-5.5-2.7-8.3-4c6.1-0.6,12.3-1.2,18.4-1.8C500.1,260.2,496.7,262.1,493.4,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M412.5,333c4.1-1,8.3-2,12.4-3c-1.6,2.9-3.1,5.8-4.7,8.8C417.6,336.8,415,334.9,412.5,333z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M444.4,323.6c2.6,0,5.2,0,7.8,0c-1.6,2.1-3.3,4.3-4.9,6.4C446.4,327.8,445.4,325.7,444.4,323.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M460.3,321.5c1.5-1.8,3.1-3.6,4.6-5.3c1,2.4,2,4.9,2.9,7.3C465.3,322.9,462.8,322.2,460.3,321.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M398,341.1c0.9,1.7,1.8,3.4,2.7,5.1c1.1-1.4,2.2-2.7,3.3-4.1C401.9,341.7,399.9,341.4,398,341.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M398.1,146.6c0.7,2.8,1.4,5.7,2,8.5c2.8-2.1,5.5-4.2,8.3-6.3C405,148,401.5,147.3,398.1,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M382.2,172c0.3,2.2,0.5,4.3,0.8,6.5c2.9-1.7,5.8-3.4,8.8-5.1C388.6,173,385.4,172.5,382.2,172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356,117.8c0.5,2.6,0.9,5.3,1.4,7.9c2.3-2.1,4.6-4.3,6.9-6.4C361.6,118.8,358.8,118.3,356,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M370,132.8c2.2-1.4,4.5-2.8,6.7-4.2c0,2.7,0,5.3,0.1,8C374.5,135.3,372.3,134,370,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298,73.7c3-1.5,5.9-2.9,8.9-4.4c-2.5-2-5.1-4.1-7.6-6.1C298.8,66.6,298.4,70.2,298,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M289.2,65.6c2.4,0.8,4.8,1.7,7.2,2.6c0.5-2.6,1-5.1,1.5-7.7C295,62.2,292.1,63.9,289.2,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.2,60.6c1-1.3,2-2.6,3.1-3.9c-1.9-0.5-3.8-1.1-5.6-1.6C285.5,56.9,286.4,58.8,287.2,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M343.5,105.5c1.1,2.9,2.1,5.9,3.2,8.8c2.2-2.3,4.4-4.7,6.7-7C350.1,106.8,346.8,106.1,343.5,105.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.3,60.4c1.3-1.3,2.5-2.6,3.8-3.9c-1.3-0.6-2.6-1.1-3.9-1.7C302.3,56.7,302.3,58.6,302.3,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M459.9,162.8c-1.2,2.5-2.4,4.9-3.6,7.4c2.9,0.2,5.8,0.4,8.6,0.6C463.2,168.1,461.5,165.5,459.9,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M455.5,149.5c-0.8,1.5-1.5,2.9-2.3,4.4c2.3,0.7,4.5,1.4,6.8,2.1C458.5,153.8,457,151.7,455.5,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424.7,151.1c-1.3,1.4-2.6,2.8-3.9,4.2c1.6,0,3.2,0,4.7,0.1C425.3,154,425,152.5,424.7,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M443.6,130.8c-1.2,1.9-2.4,3.9-3.6,5.8c1.9,0,3.7,0.1,5.6,0.1C444.9,134.7,444.3,132.7,443.6,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.8,116.9c-0.6,1.9-1.2,3.8-1.8,5.7c1.6-0.4,3.1-0.8,4.7-1.2C441.7,119.9,440.8,118.4,439.8,116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M445.9,108.5c-0.4,1.7-0.9,3.3-1.3,5c1.9-0.4,3.8-0.8,5.7-1.2C448.8,111,447.3,109.7,445.9,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M418.3,101.5c-0.4,1.5-0.7,3.1-1.1,4.6c1.4-0.5,2.7-1,4.1-1.4C420.3,103.6,419.3,102.6,418.3,101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M427.3,90.1c0,2.2-0.1,4.3-0.1,6.5c1.6-0.9,3.2-1.8,4.8-2.7C430.5,92.6,428.9,91.3,427.3,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M403.8,82.7c1.4,2.1,2.8,4.3,4.2,6.4c1.2-2.5,2.4-5,3.7-7.5C409,81.9,406.4,82.3,403.8,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M398.7,66.3c1.1,1.6,2.2,3.1,3.4,4.7c0.7-1.8,1.4-3.5,2-5.3C402.3,65.9,400.5,66.1,398.7,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M385.5,66.2c1.3,1.9,2.5,3.8,3.8,5.8c1.1-1.9,2.2-3.8,3.2-5.8C390.2,66.2,387.8,66.2,385.5,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M366.5,65.3c1.2,0.8,2.5,1.6,3.7,2.4c0-1.6,0-3.1,0-4.7C369,63.8,367.8,64.5,366.5,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.3,60.2c2.1,0.5,4.1,0.9,6.2,1.4c-0.7-1.7-1.3-3.5-2-5.2C363.1,57.7,361.7,58.9,360.3,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M347.2,62.9c1.1-0.2,2.2-0.4,3.3-0.6c-0.7-1.1-1.3-2.1-2-3.2C348.1,60.4,347.7,61.6,347.2,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339,61.5c1.3-0.4,2.6-0.9,4-1.3c-1.2-0.9-2.4-1.9-3.7-2.8C339.2,58.8,339.1,60.1,339,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M326.4,60.2c1.4-0.9,2.9-1.9,4.3-2.8c-1.5-0.3-2.9-0.7-4.4-1C326.4,57.7,326.4,58.9,326.4,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M324.1,66c1.4-0.7,2.7-1.3,4.1-2c-1-0.8-1.9-1.6-2.9-2.5C324.9,63.1,324.5,64.6,324.1,66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M324.1,71.8c1-0.9,2.1-1.8,3.1-2.7c-1-0.2-2.1-0.4-3.1-0.7C324.1,69.5,324.1,70.7,324.1,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.1,86.3c2.3,0,4.6,0,6.9-0.1c-1.6-2.1-3.2-4.2-4.8-6.2C299.5,82.1,298.8,84.2,298.1,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.5,76.6c1.5,2,3.1,3.9,4.6,5.9c1.3-2.3,2.6-4.5,3.9-6.8C296.1,76,293.3,76.3,290.5,76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.8,130.3c1.2,2,2.5,3.9,3.7,5.9c1.1-2.4,2.1-4.9,3.2-7.3C273.4,129.4,271.1,129.9,268.8,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.8,137.1c2.9,2,5.8,4,8.6,6c-0.8-3.7-1.6-7.3-2.4-11C307,133.7,304.9,135.4,302.8,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M288,212c1.6-0.1,3.3-0.3,4.9-0.4c-1-4.1-2-8.3-3-12.4C289.2,203.4,288.6,207.7,288,212z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.9,100c0.5-2.3,1.1-4.5,1.6-6.8c-1.6,0.6-3.3,1.2-4.9,1.8C193.7,96.7,194.8,98.4,195.9,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.2,83.8c0.1,2,0.1,3.9,0.2,5.9c-1.1-0.9-2.2-1.7-3.4-2.6C153.1,86,154.1,84.9,155.2,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.2,87.7c0.3,1.2,0.6,2.3,0.9,3.5c-0.9-0.5-1.8-1.1-2.7-1.6C169,89,169.6,88.4,170.2,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M161.3,98c0.3,1.1,0.6,2.2,0.8,3.3c-1-0.5-2-1-3-1.5C159.9,99.1,160.6,98.6,161.3,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.2,106.7c0.6,1.5,1.2,3,1.8,4.4c-1.3-0.4-2.5-0.7-3.8-1C152.9,108.9,153.6,107.8,154.2,106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.4,109.8c0,1.2,0.1,2.4,0.1,3.6c-1-0.4-2-0.7-3-1.1C160.5,111.5,161.4,110.6,162.4,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M159.6,113.5c1-0.4,1.9-0.9,2.9-1.3c-1-0.6-2-1.2-3-1.8C159.5,111.4,159.5,112.5,159.6,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.5,114.8c1-0.4,2-0.7,3-1.1c-0.9-0.5-1.8-1-2.7-1.5C154.7,113,154.6,113.9,154.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.3,123.3c0.4-0.9,0.8-1.8,1.1-2.7c-1,0-2.1,0.1-3.1,0.1C144,121.5,144.6,122.4,145.3,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.2,128.8c0-0.9-0.1-1.9-0.1-2.8c-0.9,0.5-1.8,1-2.8,1.5C134.3,127.9,135.3,128.4,136.2,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M137.1,132.5c0-0.9,0-1.8-0.1-2.7c-0.9,0.5-1.8,1-2.7,1.5C135.3,131.7,136.2,132.1,137.1,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M137.8,136.4c-0.5-1.3-1-2.6-1.5-3.9c-0.6,1.2-1.2,2.3-1.8,3.5C135.6,136.2,136.7,136.3,137.8,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.1,148.4c-0.7-0.9-1.4-1.7-2-2.6c-0.3,0.9-0.5,1.8-0.8,2.7C136.3,148.5,137.2,148.4,138.1,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.8,144.7c-0.7-0.9-1.3-1.8-2-2.6c-0.3,0.9-0.7,1.8-1,2.7C143.9,144.8,144.8,144.8,145.8,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.4,108.9c1,0,2.1-0.1,3.1-0.1c-0.5-0.7-1-1.4-1.5-2.1C168.4,107.4,167.9,108.1,167.4,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173.8,105c1.1,0.3,2.2,0.6,3.2,0.8c0.1-1,0.3-1.9,0.4-2.9C176.2,103.6,175,104.3,173.8,105z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177.5,106.3c0.6,0.6,1.1,1.1,1.7,1.7c0.7-0.6,1.3-1.2,2-1.8C180,106.2,178.7,106.3,177.5,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.2,107.9c0.5,0.7,1,1.5,1.5,2.2c0.6-1,1.2-2,1.8-2.9C183.4,107.4,182.3,107.7,181.2,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M182.8,112.7c0.5,0.8,0.9,1.5,1.4,2.3c0.7-0.8,1.4-1.6,2.1-2.5C185.1,112.6,183.9,112.7,182.8,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.1,69.2c0.6-1,1.1-1.9,1.7-2.9c-1.7,0.3-3.3,0.7-5,1C199.9,67.9,201,68.6,202.1,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.2,118.4c1.4,0.3,2.8,0.6,4.1,0.9c-1,0.4-1.9,0.8-2.9,1.2C146,119.8,145.6,119.1,145.2,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.6,115c0.9,0.4,1.8,0.8,2.6,1.2c-0.7,0.4-1.3,0.8-2,1.3C149,116.7,148.8,115.8,148.6,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.8,72c1.8-0.1,3.7-0.1,5.5-0.2c-1,0.9-2.1,1.8-3.1,2.7C192.4,73.7,191.6,72.8,190.8,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.3,63.3c1,0.2,1.9,0.3,2.9,0.5c-0.9,0.7-1.9,1.4-2.8,2C211.4,64.9,211.3,64.1,211.3,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M214.1,59.7c1.1,0.4,2.3,0.9,3.4,1.3c-1,0.4-1.9,0.9-2.9,1.3C214.4,61.5,214.3,60.6,214.1,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.5,60.1c1,0,2-0.1,3-0.1c-0.5-0.8-1-1.6-1.5-2.4C226.4,58.4,225.9,59.3,225.5,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.5,58c1.1,0.4,2.2,0.7,3.3,1.1c0-1,0-1.9-0.1-2.9C234.6,56.8,233.6,57.4,232.5,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M242,51c0.7,0.6,1.4,1.2,2.1,1.9c0.9-0.9,1.7-1.7,2.6-2.6C245.2,50.5,243.6,50.8,242,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.2,50.1c0.9,0.4,1.7,0.8,2.6,1.1c0.6-0.9,1.2-1.8,1.9-2.8C254.2,49.1,252.7,49.6,251.2,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.8,49.8c0.8,0.4,1.6,0.9,2.5,1.3c0.6-0.9,1.1-1.8,1.7-2.8C260.6,48.8,259.2,49.3,257.8,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.8,46c1.3,0.3,2.5,0.6,3.8,0.8c0.4-0.7,0.8-1.4,1.2-2.1C273.1,45.2,271.5,45.6,269.8,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M274.8,47.7c1,0.6,1.9,1.1,2.9,1.7c0.6-0.9,1.2-1.8,1.7-2.7C277.9,47,276.4,47.4,274.8,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277.5,51.5c0.9,0.6,1.8,1.2,2.7,1.7c1-0.6,2-1.2,3-1.8C281.3,51.4,279.4,51.5,277.5,51.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.8,
      enableBackground: "new"
    },
    width: 2383,
    height: 2375,
    xlinkHref: "FD8171C0437A61F9.png",
    transform: "matrix(0.2393 0 0 0.2393 26.8028 22.8183)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "594.6,305.9 588.2,365.9 570,421.2 540.1,472.5 503,513.9 465.4,541.8 413.6,567.4 357.7,582.6  312.6,586.9 266.9,582.6 211.8,567.4 159.8,542.1 122.1,513.9 84.6,471.9 55.1,421.1 37.1,366.4 30.6,305.9 36.7,247.2  54.9,191.2 83.4,141.6 119.4,101.1 159.3,69.8 222.4,39.4 267.8,28.5 312.8,25.4 356.2,28.4 400.1,38.7 466.2,69.4 506.1,100.8  542.7,142.9 571.2,193.4 588.5,247.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.3,247.3l33.2-9.3l0,0l0,0l30-2.8l30-2.7l30-2.6l3.8-0.3l1.9-0.2h0.5h0.2h0.3h0.9l7.5-0.2l15.1-0.4l120.5-2.9h0.5h0.2 h0.3h0.9h1.9l3.8,0.1l7.5,0.2l15.1,0.4l30.1,0.7l60.3,1.4l15.1,0.4l3.8,0.1l1.9,0.1h0.9l1,0.1l7.5,0.6l30,2.6l30,2.6l30,2.7l0,0 l0,0l33.9,10.3l-34.1-9.6h0.1l-30.1-2.1l-30.1-2.2l-30.1-2.2l-7.5-0.6l-0.9-0.1h-0.9h-1.9l-3.8-0.1l-15.1-0.2L312,228.8 l-120.5,2.4l-15.1,0.2l-7.5,0.1H168h-0.1h-0.1h-0.2h-0.5l-1.9,0.1l-3.8,0.3l-30.1,2.3l-30.1,2.3l-30.1,2.2h0.1L38.3,247.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.9,190.8l16.4-7.9l16.4-7.9h0.1h0.1l23-3.4l23-3.3l46-6.5l0,0h0.1c11-0.5,22-1,33-1.5l33-1.4l66-2.7h0.1h0.1l65,2.5 l32.5,1.3l16.3,0.6l16.3,0.7h0.1l0,0l46.8,6.7l23.4,3.4l23.4,3.4h0.1h0.1l16.6,9.1l16.6,9.2l-16.8-8.7l-16.8-8.8h0.2l-23.5-3 l-23.5-3l-46.9-6.1h0.1l-16.3-0.5l-16.3-0.6l-32.5-1.1l-65-2.3h0.1l-66.1,2.5l-33,1.2c-11,0.4-22,0.8-33,1.1h0.1l-46.1,6l-23,3 L89,175.7h0.1l-16.5,7.5L55.9,190.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.3,141.4l15.8-8.5l15.9-8.4h0.1h0.1l24.2-5.5c4-0.9,8.1-1.8,12.1-2.7l12.1-2.6l12.1-2.5l12.2-2.4l6.1-1.1l3.1-0.5 c1.1-0.2,2.1-0.3,3.1-0.4c2-0.3,4.1-0.4,6.2-0.6l6.2-0.5l12.4-0.9c4.1-0.3,8.2-0.5,12.4-0.7l24.7-1.3c16.5-0.8,33-1.5,49.5-2.2 h0.1h0.1l56.6,3.2l28.3,1.6l28.3,1.8h0.1h0.1l41.1,8.3l41.1,8.4h0.1h0.1l17,9.5l16.9,9.6l-17.2-9l-17.2-9.1l0.2,0.1l-41.2-7.9 l-41.2-7.9h0.1l-28.3-1.3l-28.3-1.4l-56.6-2.9h0.1c-16.5,0.6-33,1.2-49.5,1.9l-24.7,1.1l-12.4,0.6l-12.4,0.6l-6.2,0.4 c-2,0.2-4.1,0.3-6.1,0.5c-1,0.1-2.1,0.2-3.1,0.3l-3,0.5l-6.1,1L177,113l-12.1,2.4c-16.2,3.3-32.4,6.6-48.5,10h0.1l-16.1,8.1 L84.3,141.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.5,69.5c6.3-0.9,12.6-1.8,18.9-2.7c6.3-0.9,12.6-1.8,18.9-2.6l18.9-2.5l4.7-0.6l2.4-0.3l2.4-0.2l9.5-0.7l38-2.5 l38-2.4h0.1h0.1l43.2,1.9l43.2,2h0.1h0.1l33.4,5.2c5.6,0.8,11.1,1.8,16.7,2.7c5.6,0.9,11.1,1.8,16.6,2.8 c-5.6-0.6-11.2-1.2-16.8-1.9c-5.6-0.7-11.2-1.3-16.8-2l-33.5-4.2h0.1l-43.2-1.6l-43.2-1.8h0.2l-38,2.2l-38,2.1l-9.5,0.5l-2.3,0.1 l-2.4,0.3l-4.7,0.5l-18.9,2c-6.3,0.7-12.6,1.3-19,1.9C173.1,68.4,166.8,69,160.5,69.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.6,306.7c0,0,8.8-0.1,24.2-0.3c7.7-0.1,17-0.2,27.8-0.3c10.7-0.1,22.8-0.2,36-0.3c13.2-0.1,27.5-0.2,42.6-0.2 c15.1-0.1,31.1-0.2,47.6-0.2c33-0.1,68.2-0.1,103.4-0.2c35.2,0.1,70.4,0.1,103.4,0.2c16.5,0,32.4,0.1,47.6,0.2 c15.1,0.1,29.4,0.2,42.6,0.2c13.2,0.1,25.3,0.2,36,0.3c10.7,0.1,20.1,0.2,27.8,0.3c15.4,0.2,24.2,0.3,24.2,0.3s-8.8,0.1-24.2,0.3 c-7.7,0.1-17,0.2-27.8,0.3c-10.7,0.1-22.8,0.2-36,0.3c-13.2,0.1-27.5,0.2-42.6,0.2c-15.1,0.1-31.1,0.2-47.6,0.2 c-33,0.1-68.2,0.1-103.4,0.2c-35.2-0.1-70.4-0.1-103.4-0.2c-16.5,0-32.4-0.1-47.6-0.2c-15.1-0.1-29.4-0.2-42.6-0.2 c-13.2-0.1-25.3-0.2-36-0.3c-10.7-0.1-20.1-0.2-27.8-0.3C39.4,306.8,30.6,306.7,30.6,306.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.4,366.1l32.6,8.5h-0.1l30.1,2.2l30.1,2.2l30.1,2.3l3.8,0.3l1.9,0.1h0.5h0.2c-0.1,0,0,0,0.1,0h0.1h0.9l7.5,0.1 l15.1,0.2l120.5,2.4l120.5-2.3l15.1-0.2l3.8-0.1h1.9h0.9l0.9-0.1l7.5-0.6l30.1-2.2l30.1-2.2l30.1-2.1h-0.1l34.3-9.1l-34.1,9.9 l0,0l0,0l-30,2.7l-30,2.6l-30,2.6l-7.5,0.6l-1,0.1h-0.9l-1.9,0.1l-3.8,0.1l-15.1,0.4l-60.3,1.4l-30.1,0.7l-15.1,0.4l-7.5,0.2 l-3.8,0.1h-1.9H313h-0.3h-0.2H312l-120.5-2.9l-15.1-0.4l-7.5-0.2H168h-0.3h-0.2H167l-1.9-0.2l-3.8-0.3l-30-2.6l-30-2.7l-30-2.7 l0,0l0,0L38.4,366.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56,420.8l16,6.9l16,6.9h-0.1c15.4,1.9,30.8,3.8,46.1,5.8l46.1,5.9H180c11,0.4,22,0.7,33,1.1l33,1.2l66,2.4h-0.1 l66.4-2.3l33.2-1.2l16.6-0.6l16.6-0.5h-0.1l45.6-6l22.8-3l22.8-2.9h-0.1l16.8-7l16.8-6.9l-16.6,7.4l-16.6,7.3l0,0H536l-22.7,3.4 l-22.7,3.3l-45.5,6.6l0,0H445l-16.6,0.7l-16.6,0.7l-33.2,1.3l-66.4,2.6h-0.1H312l-66-2.7l-33-1.4c-11-0.4-22-0.9-33-1.4h-0.1l0,0 l-46-6.5c-15.3-2.1-30.7-4.4-46-6.6h-0.1h-0.1L71.8,428L56,420.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.2,471.8c9.1,4.6,18.1,9.3,27.2,14h-0.1l43,8.6l43,8.7h-0.1l29,1.4L256,506l57.9,3.1h-0.2l56.4-3.1l28.2-1.5l28.2-1.4 h-0.2l43-9.2l43-9.1h-0.1c8.9-4.2,17.8-8.4,26.8-12.6c-8.8,4.5-17.6,8.9-26.4,13.3l0,0h-0.1l-42.9,9.8l-42.9,9.7h-0.1h-0.1 l-28.2,1.9l-28.2,1.7l-56.4,3.4h-0.1h-0.1l-57.9-3.4l-28.9-1.7l-28.9-1.9h-0.1h-0.1l-42.9-9.2l-42.9-9.3h-0.1l0,0 C103,481.7,94.1,476.8,85.2,471.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.1,512.9c3.8,2.9,7.7,5.8,11.5,8.7l11.5,8.8l-0.2-0.1l18.6,3.8l18.6,3.9l37.2,7.7h-0.2c7.8,0.5,15.6,1,23.4,1.6 l23.4,1.6l46.8,3.2h-0.2l45.6-3.6l22.8-1.8c7.6-0.6,15.2-1.2,22.8-1.8h-0.2l39.2-8.5l19.6-4.3l19.6-4.2l0.1,0.1l10.5-7l10.5-7 l-10.2,7.5l-10.2,7.4l-0.1,0.1h-0.1l-19.5,4.6l-19.6,4.5l-39.1,9.1h-0.1H404c-7.6,0.7-15.2,1.3-22.8,2l-22.8,1.9l-45.6,3.9h-0.1 h-0.1l-46.8-3.5l-23.4-1.7c-7.8-0.6-15.6-1.1-23.4-1.8h-0.1h-0.1l-37.1-8.3l-18.5-4.1l-18.5-4.2h-0.1l-0.1-0.1l-11.2-9.2 C129.5,519.1,125.8,516,122.1,512.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.2,578.1L233,562.6l-14.2-15.5l0,0V547L208,525.8l-10.7-21.3v-0.1v-0.1L179,447.7v-0.1v-0.1 c-1.9-10.7-3.9-21.5-5.7-32.2l-5.7-32.2V383v-0.1l-4.4-76.1v-0.1v-0.1l3.6-76.4v-0.1V230l6.5-33.8l3.3-16.9l3.3-16.9v-0.1v-0.1 l17.7-54.6v-0.1v-0.1l13-23l13.1-23l0,0l0,0L244,35.3l0.1-0.1h0.1l24.1-6.8l-24,7.4l0.1-0.1l-19.6,26.7v-0.1L212,85.5l-12.8,23.1 l0.1-0.2L182,163.2v-0.1l-3.1,16.9l-3.2,16.9l-6.4,33.8v-0.2l-3.3,76.4v-0.2l4.2,76.2v-0.2l5.6,32.2c1.9,10.7,3.7,21.5,5.5,32.2 v-0.2l17.6,56.8v-0.1l10.4,21.4l10.3,21.5l-0.1-0.1l13.9,15.8L247.2,578.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.3,531.4l-34.5-44.9l0,0v-0.1c-8.3-17-16.4-34.1-24.7-51.1v-0.1v-0.1l-8.4-30l-8.4-30V375v-0.1L64,307.3v-0.1v-0.1 l3.1-34.5l3.2-34.5V238v-0.1L87.7,175v-0.1l0.1-0.1l27.5-50.3v-0.1l0.1-0.1l23.1-27.2l23.2-27.2l0.1-0.1h0.1l51.9-26.3 l-51.4,27.2l0.2-0.1l-22.8,27.5l-22.9,27.4l0.1-0.2l-27.2,50.5l0.1-0.2l-17.2,63v-0.2l-3.1,34.5l-3.2,34.5v-0.2l5.9,67.7v-0.2 l8.2,30.1l8.1,30.1l-0.1-0.1c8,17.1,16.1,34.2,24.1,51.4l-0.1-0.1L146.3,531.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.8,578.3l24.6-30.1v0.1L414,526l11.8-22.3l-0.1,0.1l17.6-56.8v0.2L446,431l2.8-16.1l5.6-32.2v0.2l4.2-76.2v0.2 l-3.3-76v0.2l-6.6-34.1c-2.2-11.4-4.4-22.8-6.5-34.2v0.1L425,108.6l0.1,0.2l-12.6-23.1L400,62.6l0.1,0.1L378.6,36l0.1,0.1 l-22.2-7.6l22.4,7.1h0.1l0.1,0.1L401,62l0,0v0.1L413.9,85l12.8,22.9v0.1v0.1l17.6,54.2v0.1v0.1c2.3,11.4,4.6,22.7,6.8,34.1 l6.8,34.1v0.1v0.1l3.6,76v0.1v0.1l-4.4,76.1v0.1v0.1l-5.7,32.2l-2.8,16.1l-2.9,16.1v0.1v0.1l-18.3,56.6v0.1v0.1l-12.1,22.1 L403,548.6l0,0l0,0L377.8,578.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "482.3,528.4 512,484.9 512,485 524,459.8 536.1,434.6 536,434.8 544.1,404.7 552.3,374.7 552.3,374.8  558.2,307.1 558.2,307.3 555,272.8 551.9,238.2 551.9,238.4 535.9,175.5 536,175.8 509.9,126.4 510.1,126.5 486,98.6 462,70.6  462.1,70.7 411.1,43.6 462.6,69.8 462.7,69.9 462.7,69.9 487.1,97.6 511.5,125.3 511.5,125.4 511.6,125.5 537.9,174.8  537.9,174.9 537.9,175 554.2,237.8 554.2,237.9 554.3,238 557.5,272.5 560.6,307.1 560.6,307.2 560.6,307.3 554.4,375  554.4,375.1 554.4,375.2 546,405.2 537.6,435.2 537.6,435.3 537.5,435.4 525.2,460.4 512.9,485.4 512.8,485.5 512.8,485.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M313.6,586.8c0,0-0.1-8.8-0.3-24.1c-0.1-7.7-0.2-17-0.3-27.7c-0.1-10.7-0.2-22.8-0.3-35.9c-0.1-13.2-0.2-27.4-0.2-42.5 c-0.1-15.1-0.2-31-0.2-47.4c-0.1-32.9-0.1-68-0.2-103.1c0.1-35.1,0.1-70.2,0.2-103.1c0-16.4,0.1-32.3,0.2-47.4 c0.1-15.1,0.2-29.3,0.2-42.5c0.1-13.2,0.2-25.2,0.3-35.9c0.1-10.7,0.2-20,0.3-27.7c0.2-15.4,0.3-24.1,0.3-24.1s0.1,8.8,0.3,24.1 c0.1,7.7,0.2,17,0.3,27.7c0.1,10.7,0.2,22.8,0.3,35.9c0.1,13.2,0.2,27.4,0.2,42.5c0.1,15.1,0.2,31,0.2,47.4 c0.1,32.9,0.1,68,0.2,103.1c-0.1,35.1-0.1,70.2-0.2,103.1c0,16.4-0.1,32.3-0.2,47.4s-0.2,29.3-0.2,42.5 c-0.1,13.2-0.2,25.2-0.3,35.9c-0.1,10.7-0.2,20-0.3,27.7C313.7,578,313.6,586.8,313.6,586.8z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M129.7,232.9c0,18.8,0,93,0,120.3c0,27.3,52.3,27.3,52.3,0s0-30.4,0-30.4h-17.6c0,0,0,20.1,0,29.8 c0,9.7-17.6,9.1-17.6,0s0-107.5,0-115.4s16.4-8.5,16.4,0s0,28.6,0,28.6h19.5c0,0,0-15.8,0-29.1 C182.6,209.8,129.7,209.8,129.7,232.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.7,
    y: 218.9,
    className: "st7",
    width: 17.6,
    height: 150.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M446.5,238.2c0,12.1,0,20.6,0,20.6h17.6c0,0,0-9.7,0-21.3c0.6-9.7,20.1-9.7,20.1,0s0,38.3,0,38.3 s-40.1,2.4-40.1,20c0,20.7,0,33.4,0,60.8c0,20,40.7,20,40.7,8.5c0.4-1.7,1.8,5.5,1.8,5.5h15.8c0,0,0-116,0-132.4 C502.4,210.2,446.5,209.6,446.5,238.2 M483.5,351.2c0,14-21.3,12.8-21.3,0c0-14.6,0-36.4,0-46.8c0-10.3,21.3-13.4,21.3-13.4 S483.5,337.2,483.5,351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M395.1,176.4c0,0,0.1,35.2,0.1,46.7c-11.9-11.9-40.7-3.6-41.3,14c0,22.5,0,83.2,0,113 c0,25.5,32.8,29.2,41.3,15.2c0,4.2,0,5.5,0,5.5H414V176.3 M395.2,348.3c0,11.6-22.5,14.6-22.5,0s0-91.7,0-104.5 c0-12.8,22.5-12.2,22.5,0C395.2,255.9,395.2,336.7,395.2,348.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M215.4,237.7c0,12.1,0,20.6,0,20.6H233c0,0,0-9.7,0-21.3c0.6-9.7,20.1-9.7,20.1,0s0,38.3,0,38.3 s-40.1,2.4-40.1,20c0,20.7,0,33.4,0,60.8c0,20,40.7,20,40.7,8.5c0.4-1.7,1.8,5.5,1.8,5.5h15.8c0,0,0-116,0-132.4 C271.3,209.8,215.4,209.2,215.4,237.7 M252.4,350.7c0,14-21.3,12.8-21.3,0c0-14.6,0-36.4,0-46.8c0-10.3,21.3-13.4,21.3-13.4 S252.4,336.7,252.4,350.7z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 394.1,
    y1: 176.3,
    x2: 415,
    y2: 176.3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaidaLogoFaded);
export default __webpack_public_path__ + "static/media/CaidaLogoFaded.81700af8bb23440ef2b52566dfa178aa.svg";
export { ForwardRef as ReactComponent };